module.exports = require('./helpers/bundle-url').getBundleURL('01RMl') + "Dean-min.8f3ac48c.jpg";